import { GET_GIFTS, UPDATE_GIFT } from "actions/ActionTypes";
import { putApi } from "actions/SendActions";
import { fetchApi } from "actions/FetchActions";

export const sendGift = (uuid, token, projectSlug, t) =>
  putApi({
    endpoint: `/api/offer/v4/admin/gifts/${uuid}`,
    type: UPDATE_GIFT,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    token,
    data: { resend_email: true },
    message: t("editor-notif:saveSuccess"),
    error: t("editor-notif:saveError"),
  });
